module.exports = __webpack_public_path__ + "img/movimiento-suelos.aac562e7.png";